import {Stack, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../i18n/translations';
import {CardCollapse} from '../../shared/card-collapse';

interface HistoryLogsHeaderProps {
  children: React.ReactNode;
  isCompact?: boolean;
}

export function LogsHeader(props: HistoryLogsHeaderProps) {
  const {t} = useTranslation();

  return (
    <Stack className="history-logs" flexDirection="column" gap={2}>
      <CardCollapse
        cardProps={{
          sx: {
            background: props.isCompact ? 'var(--dcm-white-base)' : 'var(--dcm-bgseniormenu)',
            borderRadius: '5px!important',
            maxWidth: '100%',
            boxShadow: props.isCompact ? '0px 4px 16px 0px rgba(29, 41, 57, 0.1) ' : 'none',
            padding: '10px',
          },
        }}
        collapsableHeader={
          <Stack
            flexDirection="row"
            alignContent="center"
            alignItems="center"
            justifyContent="space-between"
            gap="2"
            sx={{width: '100%'}}
          >
            <Typography
              sx={{
                fontSize: '18px',
                fontWeight: '500',
                lineHeight: '18px',
                letterSpacing: '0em',
                textAlign: 'left',
                color: 'var(--dcm-gray)',
                maxWidth: '80%',
              }}
              noWrap
            >
              {t(translations.care_and_activities.handle_task_modal.history.title)}
            </Typography>
          </Stack>
        }
        defaultExpand
      >
        {props.children}
      </CardCollapse>
    </Stack>
  );
}
